'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import Small from 'UIComponents/elements/Small';
import H7 from 'UIComponents/elements/headings/H7';
import HR from 'UIComponents/elements/HR';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIHelpLink from 'UIComponents/tooltip/UIHelpLink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import styled from 'styled-components';
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { EmailValidationStates, EmailValidationStateNames, Urls } from 'ExportDialog/Constants';

function createValueExtractor(onChangeCallback) {
  return event => {
    onChangeCallback(event.target.value);
  };
}

const stateToLang = {
  [EmailValidationStates.VALID]: null,
  [EmailValidationStates.INVALID]: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "exportDialog.emailErrors.invalidEmail"
  })
};

const isSend = preference => {
  return preference === 'SEND';
};

const isEmailNotValid = validationState => {
  return validationState !== EmailValidationStates.VALID;
};

const getNotificationText = (email, notification, value) => {
  if (email && notification) {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "exportDialog.preference.exportToBothText_jsx",
      options: {
        url: Urls.notificationCenterUrl,
        value
      },
      elements: {
        Link: UILink
      }
    });
  } else if (email) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "exportDialog.preference.exportToEmailText",
      options: {
        value
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "exportDialog.preference.exportToNotificationCenterText_jsx",
      options: {
        url: Urls.notificationCenterUrl
      },
      elements: {
        Link: UILink
      }
    });
  }
};

const getEmailInputField = (validationState, value, onChange) => {
  return /*#__PURE__*/_jsx(UIFormControl, {
    className: "p-top-0",
    label: /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.emailAddressLabel"
      })
    }),
    help: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "exportDialog.fields.emailAddressLabelDescription"
      })
    }),
    error: validationState !== EmailValidationStates.VALID,
    validationMessage: stateToLang[validationState],
    children: /*#__PURE__*/_jsx(UITextInput, {
      value: value,
      onChange: createValueExtractor(onChange)
    })
  });
};

const getNotificationHelpText = (preferences, value) => {
  return /*#__PURE__*/_jsx(Small, {
    use: "help",
    children: getNotificationText(isSend(preferences.EMAIL), isSend(preferences.NOTIFICATION_SIDEBAR), value)
  });
};

const StyledH7 = styled(H7).withConfig({
  displayName: "EmailFieldAndNotificationHelpText__StyledH7",
  componentId: "sc-1b07059-0"
})(["line-height:24px;"]);

const EmailFieldAndNotificationHelpText = ({
  onChange,
  validationState,
  value,
  preferences
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      align: "start",
      justify: "between",
      direction: "row",
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(StyledH7, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "exportDialog.preference.sendTo"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(UIHelpLink, {
          defaultOpen: false,
          showCloseButton: true,
          content: {
            body: /*#__PURE__*/_jsx("p", {
              className: "p-top-3 p-x-3",
              children: /*#__PURE__*/_jsx(Small, {
                use: "help",
                style: {
                  textAlign: 'center'
                },
                children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                  message: "exportDialog.preference.allowlistHelpText_jsx",
                  options: {
                    allowlistUrl: {
                      url: Urls.allowlistUrl,
                      className: 'm-all-0'
                    },
                    notificationUrl: {
                      url: Urls.notificationUrl,
                      className: 'm-all-0'
                    }
                  },
                  elements: {
                    KBLink: KnowledgeBaseButton
                  }
                })
              })
            })
          },
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "exportDialog.preference.notGettingEmail"
            })
          })
        })
      })]
    }), isEmailNotValid(validationState, value) ? getEmailInputField(validationState, value, onChange) : getNotificationHelpText(preferences, value), /*#__PURE__*/_jsx(HR, {})]
  });
};

EmailFieldAndNotificationHelpText.propTypes = {
  onChange: PropTypes.func.isRequired,
  validationState: PropTypes.oneOf(EmailValidationStateNames).isRequired,
  value: PropTypes.string.isRequired,
  preferences: PropTypes.object
};
export default EmailFieldAndNotificationHelpText;